import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '@components/Icon';
import SEO from '@components/seo/SEO';
import { BackTop, Drawer } from 'antd';

// 创建图标封装组件，与LandingPage中相同
const SafeIcon = ({ icon: IconName, useFa = true, ...props }) => {
  if (typeof IconName === 'string' && Icon[IconName]) {
    const IconComponent = Icon[IconName];
    return <IconComponent useFa={useFa} {...props} />;
  }
  
  if (typeof IconName === 'function' || typeof IconName === 'object') {
    return <IconName useFa={useFa} {...props} />;
  }
  
  return null;
};

const Terms = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-purple-50 to-blue-50 dark:from-gray-900 dark:to-gray-800">
      <SEO 
        title="使用条款 - 图美啦服务协议 | 在线图片美化工具"
        description="请阅读图美啦的使用条款和服务协议，了解您使用我们图片美化服务的权利和责任，确保安全合规地使用我们的工具。"
        keywords="图美啦使用条款,服务协议,用户责任,知识产权,图片美化条款,免责声明"
        canonicalUrl="https://snapbeautify.toolooz.com/terms"
      />
      {/* 导航栏 */}
      <header className="bg-white dark:bg-gray-900 shadow-sm">
        <div className="container mx-auto px-4 py-3">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <Link to="/" className="flex items-center text-2xl font-bold text-purple-600 dark:text-purple-400">
                <img src="/favicon.svg" alt="图美啦" width="32" height="32" className="mr-2" />
                图美啦
              </Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/" className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center">
                <SafeIcon icon="Home" size={16} className="mr-1" />
                首页
              </Link>
              <Link to="/quick-start" className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center">
                <SafeIcon icon="BookOpen" size={16} className="mr-1" />
                快速上手
              </Link>
              <Link to="/about" className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center">
                <SafeIcon icon="User" size={16} className="mr-1" />
                关于我们
              </Link>
            </nav>
            <div className="flex md:hidden">
              <button 
                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                onClick={() => setMobileMenuOpen(true)}
              >
                <SafeIcon icon="Menu" size={24} />
              </button>
            </div>
          </div>
        </div>
        
        {/* 移动设备导航菜单 */}
        <Drawer
          title="导航菜单"
          placement="right"
          onClose={() => setMobileMenuOpen(false)}
          open={mobileMenuOpen}
          width={250}
        >
          <div className="flex flex-col space-y-4">
            <Link 
              to="/" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="Home" size={16} className="mr-1" />
              首页
            </Link>
            <Link 
              to="/quick-start" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="BookOpen" size={16} className="mr-1" />
              快速上手
            </Link>
            <Link 
              to="/about" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="User" size={16} className="mr-1" />
              关于我们
            </Link>
            <Link 
              to="/features" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="Star" size={16} className="mr-1" />
              功能介绍
            </Link>
            <Link 
              to="/faq" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="HelpCircle" size={16} className="mr-1" />
              常见问题
            </Link>
            <div className="border-t border-gray-200 dark:border-gray-700 my-2 pt-2">
              <Link 
                to="/privacy" 
                className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <SafeIcon icon="Shield" size={16} className="mr-1" />
                隐私政策
              </Link>
              <Link 
                to="/terms" 
                className="font-medium text-purple-600 dark:text-purple-400 flex items-center py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <SafeIcon icon="FileText" size={16} className="mr-1" />
                使用条款
              </Link>
              <Link 
                to="/copyright" 
                className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <SafeIcon icon="Award" size={16} className="mr-1" />
                版权声明
              </Link>
            </div>
          </div>
        </Drawer>
      </header>

      {/* 主要内容区域 */}
      <main className="flex-grow container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
          <div className="p-8">
            <h1 className="text-3xl font-bold text-gray-800 dark:text-white mb-6 flex items-center">
              <SafeIcon icon="FileText" className="mr-3 text-purple-600 dark:text-purple-400" size={28} />
              使用条款
              <span className="text-sm font-normal text-gray-500 dark:text-gray-400 ml-4">更新日期: 2025年3月22日</span>
            </h1>

            <div className="prose dark:prose-invert max-w-none">
              <p className="text-gray-600 dark:text-gray-300">
                欢迎使用图美啦！请仔细阅读以下条款，这些条款规定了您使用我们服务的权利和责任。通过访问或使用我们的服务，即表示您同意遵守这些条款。
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="CheckSquare" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                接受条款
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                当您访问或使用图美啦网站和服务时，即表示您已阅读、理解并同意接受这些条款的约束。如果您不同意这些条款的任何部分，请不要使用我们的服务。
              </p>
              <p className="text-gray-600 dark:text-gray-300 mt-4">
                我们保留随时修改这些条款的权利。修改后的条款将在网站上公布，并在公布后立即生效。您继续使用我们的服务，即表示您接受修改后的条款。
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="Users" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                用户责任
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                在使用图美啦服务时，您同意：
              </p>
              <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
                <li>提供真实、准确、完整和最新的信息（如适用）</li>
                <li>仅将服务用于合法目的，并遵守所有适用的法律法规</li>
                <li>不上传包含病毒、恶意代码或其他有害组件的文件</li>
                <li>不干扰或破坏服务或连接到服务的服务器和网络</li>
                <li>不尝试未经授权访问任何系统、账户或网络</li>
              </ul>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="Image" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                用户内容
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                您可能会向我们上传图片进行处理和美化。对于这些用户内容，请注意：
              </p>
              <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
                <li>您保留对您上传内容的所有权利</li>
                <li>您授予我们非排他性、免版税的许可，允许我们处理您的图片以提供服务</li>
                <li>您必须拥有上传内容的合法权利，或已获得必要的授权</li>
                <li>您不得上传侵犯他人知识产权、侵犯隐私或含有非法内容的图片</li>
              </ul>
              <p className="text-gray-600 dark:text-gray-300 mt-4">
                我们不会永久存储您上传的图片。图片处理完成后，原始文件将从我们的服务器删除。
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="Award" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                知识产权
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                图美啦及其内容（包括但不限于文本、图形、标志、图标、图像和软件）受版权、商标和其他知识产权法律的保护。这些内容是图美啦及其许可方的财产。
              </p>
              <p className="text-gray-600 dark:text-gray-300 mt-4">
                未经我们事先书面同意，您不得：
              </p>
              <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
                <li>复制、分发或公开展示网站内容</li>
                <li>使用网站内容用于任何商业目的</li>
                <li>尝试反向工程、修改或创建网站或其任何部分的衍生作品</li>
                <li>删除网站内容中的任何版权或其他专有权声明</li>
              </ul>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="Shield" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                免责声明
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                图美啦的服务按"现状"和"可用性"提供，不提供任何形式的明示或暗示保证。
              </p>
              <p className="text-gray-600 dark:text-gray-300 mt-4">
                我们不保证：
              </p>
              <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
                <li>服务将不间断、及时、安全或无错误</li>
                <li>通过使用服务获得的结果准确或可靠</li>
                <li>服务中的错误或缺陷将被纠正</li>
              </ul>
              <p className="text-gray-600 dark:text-gray-300 mt-4">
                您理解并同意，您使用服务的风险完全由您自己承担。
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="AlertTriangle" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                责任限制
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                在法律允许的最大范围内，图美啦及其关联方、合作伙伴、供应商或许可方在任何情况下均不对任何直接、间接、偶然、特殊、惩罚性或后果性损害承担责任，包括但不限于利润损失、商誉损失、数据丢失或其他无形损失。
              </p>
              <p className="text-gray-600 dark:text-gray-300 mt-4">
                这些限制适用于因以下原因引起的损害：
              </p>
              <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
                <li>使用或无法使用服务</li>
                <li>通过服务获取的替代商品和服务的成本</li>
                <li>未经授权访问或更改您的数据</li>
              </ul>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="Link" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                第三方链接
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                我们的服务可能包含指向第三方网站或服务的链接，这些链接不由我们拥有或控制。图美啦对任何第三方网站或服务的内容、隐私政策或做法不承担任何责任。
              </p>
              <p className="text-gray-600 dark:text-gray-300 mt-4">
                您进一步承认并同意，图美啦对您因使用或依赖任何第三方网站或服务的内容、商品或服务而直接或间接造成或据称造成的任何损害或损失不承担责任。
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="Flag" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                适用法律
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                这些条款应受中华人民共和国法律管辖并按其解释，不考虑法律冲突原则。
              </p>
              <p className="text-gray-600 dark:text-gray-300 mt-4">
                如果这些条款的任何条款被认为无效或不可执行，该条款将在法律允许的最大范围内执行，其他条款将继续完全有效。
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="MessageCircle" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                联系我们
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                如果您对这些使用条款有任何问题或建议，请随时联系我们：
              </p>
              <p className="text-gray-600 dark:text-gray-300 mt-2 flex items-center">
                <SafeIcon icon="Mail" size={16} className="mr-2 text-purple-500 dark:text-purple-400" />
                <a href="mailto:support@toolooz.com" className="text-purple-600 dark:text-purple-400 hover:underline">support@toolooz.com</a>
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* 页脚区域 */}
      <footer className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <Link to="/" className="flex items-center text-xl font-bold text-white">
                <img src="/favicon.svg" alt="图美啦" width="24" height="24" className="mr-2" />
                图美啦
              </Link>
            </div>
            
            <div className="flex space-x-8">
              <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors text-sm">隐私政策</Link>
              <Link to="/terms" className="text-gray-300 hover:text-white transition-colors text-sm">使用条款</Link>
              <Link to="/copyright" className="text-gray-300 hover:text-white transition-colors text-sm">版权声明</Link>
            </div>
            
            <div className="mt-4 md:mt-0 text-gray-400 text-sm">
              © {new Date().getFullYear()} 图美啦 | SnapBeautify
            </div>
          </div>
        </div>
      </footer>
      
      <BackTop>
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-purple-600 hover:bg-purple-700 text-white shadow-lg">
          <SafeIcon icon="ChevronUp" size={20} />
        </div>
      </BackTop>
    </div>
  );
};

export default Terms; 